module.exports = __webpack_public_path__ + "static/assets/f9a8b45d29c1f8953dc63e4e2decb709.png";